import Offcanvas from 'react-bootstrap/Offcanvas';
import './../css/GSideBar.css';
import './../css/Gtop.css';
import './../css/GFooter.css';
import './../css/GPage2.css';
import './../css/GPage3.css';
import './../css/GEmployers-single.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import GHeader from './GHeader';
import GFooter from './GFooter';
import GSignImg from './GSignImg'; 
import { Endpoint, getDecryptedValueByProperty, fetchOperation, handleEncode, getHeaders, systemConfiguration, includeScripts, includeBootstrapCss, includeBundleBootstrapCss, Properties } from '../../CommonImports';
import { useEffect, useState } from '../../InBuildImports';
import GEmpOpeningJob from './GEmpOpeningJob';
import GEmployersSubheader from './GEmployersSubheader';
import GEmployersSider from './GEmployersSider';




function GEmployersSingle() {
    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';
    const token = getDecryptedValueByProperty(Properties.SESSION_TOKEN_PROP);
    const [loading, setLoading] = useState(false);
    const [candidatesData, setCandidatesData] = useState([]);
    const emailId = "test@gmail.com";//systemConfiguration.SCHOOL_ID;
    const userId = "9284735629";//systemConfiguration.SCHOOL_ID;

    const Header_Json = getHeaders(token, handleEncode(userId))

    const fetchCandidatesDetails = async () => {
        setLoading(true);

        const url = `${systemConfiguration.HOST}${Endpoint.GJOBS_CONTROLLER_REQ_MAPPING + Endpoint.GET_CANDIDATE_DETAILS_BY_EMAIL}${emailId}`
        const response = await fetchOperation(url, Header_Json);
        console.log('Fetched candidates details:', response);
        setCandidatesData(response);
        setLoading(false);

    };

    useEffect(() => {
        fetchCandidatesDetails();
        includeBootstrapCss();
        includeBundleBootstrapCss();
        includeScripts();
        document.addEventListener("DOMContentLoaded", function () {
            if (window.innerWidth >= 992) {
                const sidebar = Offcanvas(document.getElementById(Properties.SIDEBAR_MENU_PROP));
                sidebar.show();
            }
        });
    }, []);


    return (
        <div>
            <GHeader />
            <GEmployersSubheader />

            <section className="section-box mt-50">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-8 col-md-12 col-sm-12 col-12">
                            <div className="GContent-single">
                                <h5>About Company</h5>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis illum fuga eveniet.
                                    Deleniti asperiores,
                                    commodi quae ipsum quas est itaque, ipsa, dolore beatae voluptates nemo blanditiis iste
                                    eius officia minus.
                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis illum fuga eveniet.
                                </p>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis illum fuga eveniet.
                                    Deleniti asperiores, commodi quae ipsum quas est itaque, ipsa, dolore beatae voluptates
                                    nemo blanditiis iste eius officia minus.
                                    Id nisi, consequuntur sunt impedit quidem, vitae mollitia!
                                </p>
                                <div className="divider"></div>
                                <h4 className="mb-20 mt-25">Branches</h4>
                                <div className="row">
                                    <div className="col-md-4 col-sm-6 col-12 mb-60">
                                        <strong className="text-md-bold">Behance Design</strong>
                                        <span className="dis-block text-muted text-md-lh24">
                                            NY, UK<br />
                                            Jan 2021 — Present
                                        </span>
                                    </div>
                                    <div className="col-md-4 col-sm-6 col-12 mb-60">
                                        <strong className="text-md-bold">Behance Accounting</strong>
                                        <span className="dis-block text-muted text-md-lh24">
                                            pxdraft Ltd, UK<br />
                                            Jan 2018 — Dec 2021
                                        </span>
                                    </div>
                                    <div className="col-md-4 col-sm-6 col-12 mb-60">
                                        <strong className="text-md-bold">Behance Creative</strong>
                                        <span className="dis-block text-muted text-md-lh24">
                                            AT Studio, UK<br />
                                            Jan 2017 — May 2017
                                        </span>
                                    </div>

                                    <div className="col-md-4 col-sm-6 col-12 mb-10">
                                        <strong className="text-md-bold">Behance Social</strong>
                                        <span className="dis-block text-muted text-md-lh24">
                                            NY, UK<br />
                                            Jan 2021 — Present
                                        </span>
                                    </div>
                                    <div className="col-md-4 col-sm-6 col-12 mb-10">
                                        <strong className="text-md-bold">Behance Search</strong>
                                        <span className="dis-block text-muted text-md-lh24">
                                            NY, UK<br />
                                            Jan 2021 — Present
                                        </span>
                                    </div>
                                    <div className="col-md-4 col-sm-6 col-12 mb-10">
                                        <strong className="text-md-bold">Behance Video</strong>
                                        <span className="dis-block text-muted text-md-lh24">
                                            NY, UK<br />
                                            Jan 2021 — Present
                                        </span>
                                    </div>
                                </div>
                                <div className="divider"></div>
                                <h4 className="mt-30 mb-30">Our Office</h4>
                                <img src={mediaUrl + "img-1.png?" + sasToken} alt="jobhub" />
                                <div className="divider"></div>
                                <h4 className="mt-30 mb-30">Vacancies</h4>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <ul>
                                            <li>Digital Designer - 03 person </li>
                                            <li>Digital Marketing - 04 persons</li>
                                            <li>Project Manager - 02 persons</li>
                                        </ul>
                                    </div>
                                    <div className="col-lg-6">
                                        <p className="text-muted lh-32">
                                            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Debitis illum fuga
                                            eveniet. Deleniti asperiores, commodi quae ipsum quas est itaque
                                        </p>
                                    </div>
                                </div>
                                <div className="divider"></div>
                                <h4 className="mb-10 mt-30">Required skills</h4>
                                <div className="GBlock-progress-status">
                                    <div className="GItem-progress">
                                        <div className="GTitle-progress"><strong className="text-md-bold">Figma</strong> (8.5/10)
                                        </div>
                                        <div className="GInfo-progress">
                                            <div className="progress">
                                                <div style={{ width: '90%' }} className="progress-bar"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="GItem-progress">
                                        <div className="GTitle-progress"><strong className="text-md-bold">Sketch</strong> (8.5/10)
                                        </div>
                                        <div className="GInfo-progress">
                                            <div className="progress">
                                                <div style={{ width: '60%' }} className="progress-bar bg-info"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="GItem-progress">
                                        <div className="GTitle-progress"><strong className="text-md-bold">After Effect</strong>
                                            (8.5/10)</div>
                                        <div className="GInfo-progress">
                                            <div className="progress">
                                                <div style={{ width: '80%' }} className="progress-bar"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="GItem-progress">
                                        <div className="GTitle-progress"><strong className="text-md-bold">Photoshop</strong>
                                            (8.5/10)</div>
                                        <div className="GInfo-progress">
                                            <div className="progress">
                                                <div style={{ width: '70%' }} className="progress-bar bg-info"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="GItem-progress">
                                        <div className="GTitle-progress"><strong className="text-md-bold">HTML &amp; CSS</strong>
                                            (8.5/10)</div>
                                        <div className="GInfo-progress">
                                            <div className="progress">
                                                <div style={{ width: '40%' }} className="progress-bar"> </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="GApply-jobs">
                                <div className="row align-items-center">
                                    <div className="col-md-5">
                                        <a href="#" className="btn btn-primary me-2">Apply now</a>
                                        <a href="#" className="btn btn-outline-secondary">Save job</a>
                                    </div>
                                    <div className="col-md-7 text-md-end social-share">
                                        <a href="#" className="btn btn-outline-primary btn-sm me-2">
                                            <img alt="jobhub" src={mediaUrl + "share-fb.svg?" + sasToken} /> Share
                                        </a>
                                        <a href="#" className="btn btn-outline-info btn-sm me-2">
                                            <img alt="jobhub" src={mediaUrl + "share-tw.svg?" + sasToken} /> Tweet
                                        </a>
                                        <a href="#" className="btn btn-outline-danger btn-sm">
                                            <img alt="jobhub" src={mediaUrl + "share-pinterest.svg?" + sasToken} /> Pin
                                        </a>
                                    </div>

                                </div>
                            </div>
                            <GEmpOpeningJob />
                        </div>


                        <GEmployersSider />
                    </div>
                </div>
            </section>

            <section className="section-box my-5">
                <GSignImg />
            </section>
            <GFooter />
        </div>
    );
}
export default GEmployersSingle;